import type { Expect } from '@quromedical/utils';
import type { ResourceType } from '../../types';

import { ExtensionUrl } from './url';

/**
 * Defines the configuration structure used in the extensions for each resource type
 */
export const resourceExtensionConfigs = {
  Task: {
    requestedPeriod: ExtensionUrl.TaskRequestedPeriod,
  },
  ClinicalImpression: {
    practitionersToNotify: [ExtensionUrl.practitionerToNotify],
    pinned: ExtensionUrl.clinicalImpressionPinned,
  },
  // TODO: Register extensions for all resources here - should stop uncontrolled access
} as const;

export type SingleExtension = ExtensionUrl;
export type ArrayExtension = Readonly<[ExtensionUrl]>;
export type ExtensionType = SingleExtension | ArrayExtension;

export type BaseExtensionConfigs = Readonly<
  Partial<Record<ResourceType, Record<string, ExtensionType>>>
>;

export type ExtensionConfigs = Expect<
  typeof resourceExtensionConfigs extends BaseExtensionConfigs
    ? typeof resourceExtensionConfigs
    : unknown
>;
